import { render, staticRenderFns } from "./formBuilderTemplatePreviewFormStyle.vue?vue&type=template&id=163c1c20&scoped=true"
import script from "./formBuilderTemplatePreviewFormStyle.vue?vue&type=script&lang=js"
export * from "./formBuilderTemplatePreviewFormStyle.vue?vue&type=script&lang=js"
import style0 from "./formBuilderTemplatePreviewFormStyle.vue?vue&type=style&index=0&id=163c1c20&prod&lang=scss&scoped=true"
import style1 from "./formBuilderTemplatePreviewFormStyle.vue?vue&type=style&index=1&id=163c1c20&prod&lang=scss&scoped=true"
import style2 from "./formBuilderTemplatePreviewFormStyle.vue?vue&type=style&index=2&id=163c1c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163c1c20",
  null
  
)

export default component.exports